export default "__VITE_ASSET__8E3aAXpx__"